import React, { useEffect, useState } from "react";
import LottieAnimation from "../../../ui/lottie";
import { useInView } from 'react-intersection-observer';

export default function PreFooterPage ()  {

  const { ref: divdRef, inView: divIsVisible } = useInView({
    threshold: .5,
    triggerOnce: true
  });
  const [isMobile, setIsMobile] = useState(true)
  const [animation, setAnimation] = useState(null)

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setIsMobile(false)
      import('../../../../../animations/lien.json').then(x =>
				setAnimation(x)
			   );
    }
  }, [divIsVisible]);

  return (
    !isMobile && animation ?
      <div ref={divdRef} className="prefooter mb-4 md:flex items-baseline justify-center container mx-auto pt-0 md:pt-4">
        <LottieAnimation size='size-tagline' animation={animation} divIsVisible={divIsVisible} />
      </div>
      : ''
  )
}
